<template>
  <div>
    <vx-card titleIcon="SearchIcon" ref="filterCard" title="Audit Log Summary" class="user-list-filters mb-8" :collapse-action="true">
      <FinishedProductAuditStockLogSummary/>
    </vx-card>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">General</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                     :options="['Development', 'Pre-Production', 'Production']"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
          <div slot="no-body" class="mt-4">

            <vs-table stripe id="formulation-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="formulations"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" sort-key="formulation-code">FORMULATION CODE</vs-th>
                <vs-th width="15%" sort-key="name">NAME</vs-th>
                <vs-th width="10%" sort-key="qa-status">QA STATUS</vs-th>
                <vs-th width="10%" class="" sort-key="status">STATUS</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickFormulationView(data[indextr].id)" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].qa_status.name">
                    <vs-chip style="font-size: x-small; border-radius: 0" transparent v-bind:color="formulationQaColorFactory(data[indextr].qa_status.id)">
                      {{data[indextr].qa_status.name}}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="font-size: x-small; border-radius: 0" transparent :color="formulationsStatusColorFactory(data[indextr].status.id)">
                      {{data[indextr].status.name}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <div class="vx-col md:w-1/5 w-full md:mb-0">
                        <vx-tooltip text="View Log" position="left">
                          <vs-button @click.stop="onClickFormulationView(data[indextr].id)"
                                    size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-can:any="['view-formulations', 'view-partial-formulation-details']"
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"></vs-pagination>

          </div>
      </div>
    </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import Utils from '@/mixins/Utils';
import {defaultPagination, perPageList} from "@/constants/config";
import ErrorMessages from "@/mixins/ErrorMessages";
const FormulationsRepository = RepositoryFactory.get('formulations')
import FinishedProductAuditStockLogSummary from './FinishedProductAuditStockLogSummary.vue';

export default {
  name: 'FormulationList',
  data () {
    return {
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      formulations: []
    }
  },
  components: {
    'v-select': vSelect,
    FinishedProductAuditStockLogSummary,
  },
  mixins : [Filter, Utils, ErrorMessages],
  async mounted () {
    this.$refs.filterCard.isContentCollapsed = false
    await this.loadFormulations()
  },
  methods: {
    async refreshData () {
      this.loadFormulations()
    },

    async onClickFormulationView (id) {
      this.$router.push(`/pages/activity-logs/fg-stock-adjust/${id}/fg-batch`)
    },
    async loadFormulations() {
      this.$vs.loading({
        container: '#formulation-table',
        scale: 0.45
      })
      try {
        const {data} = await FormulationsRepository.get(this.page, this.filterQuery, this.perPage, this.sort)
        this.formulations =  data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation-table > .con-vs-loading')
    },

    filterQueryUpdate (){
      this.page = 1
      this.loadFormulations()
    },

    handleChangePage(page) {
      this.page=page;
      this.loadFormulations()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadFormulations()
      }

    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },

  },
  watch : {
    page(){
      this.loadFormulations()
    },
    perPage() {
      this.loadFormulations()
    },
  },
  computed: {
    formulationQaColorFactory() {
      return id => {
        switch (id) {
          case 1:
            return '#a05a2a';
          case 2:
            return '#0090b5';
          case 3:
            return 'danger';
          case 4:
            return 'primary';
        }
      }

    },
    formulationsStatusColorFactory() {
      return id => {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return '#00b578';
          case 3:
            return '#b52c00';
        }
      }
    }

  }
}
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
